<template>
  <div class="base-password d-flex w-100" :class="{ is_disabled: disabled }">
    <b-form-input
      :value="value"
      :name="name"
      :type="showPassword ? 'text' : 'password'"
      @input="$emit('input', $event)"
      :placeholder="placeholder"
      :disabled="disabled"
      :id="id"
      class="flex-grow-1"
    ></b-form-input>

    <span v-if="counter" class="counter" :class="{ is_success: value.length >= minLength }">{{ value.length }}</span>

    <b-button @click="triggerShowPassword" variant="transparent" class="float-right rounded-full">
      <b-icon-eye v-if="showPassword" variant="primary"></b-icon-eye>
      <b-icon-eye-slash v-else variant="primary"></b-icon-eye-slash>
    </b-button>
  </div>
</template>

<script>
import { BFormInput, BButton, BIconEye, BIconEyeSlash } from "bootstrap-vue";

export default {
  name: "BasePassword",
  components: { BFormInput, BButton, BIconEye, BIconEyeSlash },
  props: {
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    // uses to change couner color after min length reached
    minLength: {
      type: Number,
      default: 6,
    },
    counter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    triggerShowPassword() {
      if (this.disabled) return;
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
